module.exports = __webpack_public_path__ + "img/fc-dinamo-tbilisi.d6becd43.png";